import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { transformResponseHandler } from 'utils/transformResponseHandler';

export const vendorTimingApi = createApi({
    reducerPath: 'vendorTimingApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_API_ROUTE}`,
        prepareHeaders: (headers, { getState }) => {
            const token = getState()?.posData?.token;
            if (token) {
                headers.set('Authorization', token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getVendorTimings: builder.query({
            query: () => ({
                url: `/get-vendor-timings`,
                method: 'GET',
            }),
            providesTags: ['vendor-timings'],
            // transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        updateVendorTimings: builder.mutation({
            query: (body) => ({
                url: '/update-vendor-timings',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['vendor-timings'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
    }),
});

export const {
    useGetVendorTimingsQuery,
    useUpdateVendorTimingsMutation,
} = vendorTimingApi;
